let timeout = null;

window.toggleScanMode = function (element, active) {
  if (active) {
    element.classList.add('is-loading');
    let parentModal = element.closest('.modal');
    if (!parentModal) {
      parentModal = element.closest('form');
    }

    try {
      webkit.messageHandlers.callbackHandler.postMessage("openScanner");
    } catch (err) {
      if (typeof Android !== "undefined" && Android !== null) {
        Android.openScanner();
      } else {
        if (document.querySelector('#scanner_modal')) {
          enableScanner(parentModal);
        }
        parentModal.querySelector('input[name="reference"]').focus();
      }
    }


  } else {
    element.classList.remove('is-loading');
  }
}


window.validateScannerInput = function (element) {
  clearTimeout(timeout);
  timeout = setTimeout(function () {
    validateGiftcard(element);
  }, 500);
}

window.validateGiftcard = function (referenceInput) {
  let parentModal = referenceInput.closest('.modal');
  if (!parentModal) {
    return;
  }

  parentModal.querySelector('.scan').classList.remove('is-loading');

  let redeemButton = parentModal.querySelector('button[name="redeem_button"]');
  let claimField = parentModal.querySelector('input[name="claim_value"]');
  let remainingField = parentModal.querySelector('input[name="remaining_value"]');
  let remainingBalance = parentModal.querySelector('p[name="remaining_balance"]');
  let merchantField = parentModal.querySelector('input[name="merchant"]');

  if (referenceInput.value == '') {
    if (claimField) {
      claimField.disabled = true;
      claimField.value = 0;
    }
    if (redeemButton) {
      redeemButton.disabled = true;
    }

    if (remainingBalance) {
      remainingBalance.innerHTML = '$0.00';
    }
    return;
  }

  parentModal.querySelector('#searchStatusNotFound').classList.add('is-hidden');
  parentModal.querySelector('#searchStatusRedeem').classList.remove('is-hidden');

  var data = new FormData();
  data.append("json", JSON.stringify({
    merchant_id: merchantField.value
  }));

  fetch(`/api/giftcard/${referenceInput.value}`, {
    method: 'POST',
    body: data
  })
    .then(res => {
      if (res.status == 404) {
        return res.text();
      }
      return res.json();
    })
    .then(data => {
      parentModal.querySelector('#searchStatusNotFound').classList.add('is-hidden');
      parentModal.querySelector('#searchStatusRedeem').classList.add('is-hidden');
      if (data.length == 0) {
        parentModal.querySelector('#searchStatusNotFound').classList.remove('is-hidden');

        if (redeemButton) {
          redeemButton.disabled = true;
        }

        if (claimField) {
          claimField.disabled = true;
          claimField.value = 0;
        }

        if (remainingBalance) {
          remainingBalance.innerHTML = '$0.00';
        }

        return;
      }

      if (claimField) {
        claimField.disabled = false;
        claimField.value = (data.remainingValue / 100);
      }

      if (remainingField) {
        remainingField.value = (data.remainingValue / 100);
      }

      if (remainingBalance) {
        remainingBalance.innerHTML = '$' + (data.remainingValue / 100).toFixed(2);
      }

      if (redeemButton) {
        redeemButton.disabled = false;
      }
    })
    .catch(error => console.log(error));
}

window.redeemCard = function (element) {
  let parentModal = element.closest('.modal');
  if (!parentModal) {
    return;
  }

  let merchantField = parentModal.querySelector('input[name="merchant"]');
  let referenceField = parentModal.querySelector('input[name="reference"]');
  let claimField = parentModal.querySelector('input[name="claim_value"]');
  let remainingField = parentModal.querySelector('input[name="remaining_value"]');
  let redeemButton = parentModal.querySelector('button[name="redeem_button"]');
  let userField = parentModal.querySelector('input[name="user"]');

  redeemButton.classList.add('is-loading');

  referenceField.disabled = true;
  claimField.disabled = true;

  var numberRegex = /^(?:-(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*))|(?:0|(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*))))(?:.\d+|)$/;

  if (!numberRegex.test(claimField.value)) {
    referenceField.disabled = false;
    claimField.disabled = false;
    redeemButton.classList.remove('is-loading');
    parentModal.querySelector('#redemption_error').innerHTML = `Numbers only.`;
    return;
  } else if (parseFloat(claimField.value) == 0) {
    referenceField.disabled = false;
    claimField.disabled = false;
    redeemButton.classList.remove('is-loading');
    parentModal.querySelector('#redemption_error').innerHTML = `Wrong input amount.`;
    return;
  } else if (parseFloat(claimField.value) < 0) {
    referenceField.disabled = false;
    claimField.disabled = false;
    redeemButton.classList.remove('is-loading');
    parentModal.querySelector('#redemption_error').innerHTML = `Cannot use negative amount.`;
    return;
  } else if (parseFloat(claimField.value) > parseFloat(remainingField.value)) {
    referenceField.disabled = false;
    claimField.disabled = false;
    redeemButton.classList.remove('is-loading');
    parentModal.querySelector('#redemption_error').innerHTML = `Not enough value remaining on the card to redeem this amount. $${parseFloat(remainingField.value).toFixed(2)} remaining.`;
    return;
  }
  parentModal.querySelector('#redemption_error').innerHTML = '';
  var data = new FormData();
  data.append("json", JSON.stringify({
    value: claimField.value,
    merchant_id: merchantField.value,
    user_id: userField.value,
  }));
  fetch(`/api/giftcard/${referenceField.value}/redeem`, {
    method: 'POST',
    body: data,
    credentials: 'include'
  })
    .then(result => {
      result.json().then(data => {
        if (typeof data.error !== 'undefined') {
          console.log(data);

          referenceField.disabled = false;
          claimField.disabled = false;
          redeemButton.classList.remove('is-loading');
          parentModal.querySelector('#redemption_error').innerHTML = `${data.error}`;
          return;
        } else {
          let code = referenceField.value;
          claimField.value = data.remaining;
          referenceField.disabled = false;
          if (data.remaining > 0) {
            claimField.disabled = false;
          } else {
            document.querySelector('#redeemBtn').style.display = 'none';
          }
          redeemButton.classList.remove('is-loading');
          parentModal.classList.remove('is-active');

          document.querySelector('#redemptionAlert').style.display = 'block';
          document.querySelector('#redemptionAlert').querySelector('span[name="referenceCode"]').innerHTML = code;
          document.querySelector('#remaining-value').innerHTML = data.remaining_text;
          document.querySelector('#status-value').innerHTML = data.is_active;
        }

      })
    });
}


window.enableScanner = function (parentModal, clearField = true, useScanner = true) {
  let refField = parentModal.querySelector('input[name="reference"]');
  if (useScanner && document.querySelector('#scanner_modal')) {
    let scannerModal = document.querySelector('#scanner_modal');
    scannerModal.classList.add('is-active');
    initialiseScanner(parentModal, false, () => {
      validateGiftcard(parentModal.querySelector('input[name="reference"]'));
    });
  }
  if (clearField) {
    refField.value = '';
  }
  refField.disabled = false;
  refField.readOnly = false;
  if (!document.querySelector('#scanner_modal')) {
    refField.focus();
  }
}

window.setActiveReference = function (input) {
  if (document.querySelector('.modal.is-active')) {
    document.querySelector('.modal.is-active').querySelector('input[name="reference"]').value = input;
    setTimeout(() => {
      validateGiftcard(document.querySelector('.modal.is-active').querySelector('input[name="reference"]'));
    }, 500);
  } else {
    document.querySelector('.scan.is-loading').closest('form').querySelector('input[name="reference"]').value = input;
    disableReference();
  }

}



// WEBPACK FOOTER //
// ./resources/assets/website/scripts/scanner-input.js